export default {
  name: "Password",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28.54 5.46a8.474 8.474 0 0 0-6.19-3.5 8.44 8.44 0 0 0-6.63 2.44c-2.03 2.03-2.87 4.83-2.3 7.6l-4.3 4.3c-.17.17-.27.4-.29.64l-.14 2.08-2.29.29c-.46.06-.82.43-.87.89l-.22 2.23-2.53.38c-.51.08-.88.53-.85 1.05l.3 5c.03.51.44.92.96.94l5 .2h.04c.26 0 .52-.11.71-.29l11.1-11.1c2.8.58 5.64-.29 7.68-2.38 2.82-2.9 3.17-7.53.82-10.77zm-2.25 9.37c-1.66 1.71-4.01 2.35-6.29 1.71-.35-.1-.72 0-.98.26L7.83 27.99l-3.66-.15-.19-3.19 2.4-.36c.45-.07.8-.43.85-.89l.22-2.21 2.31-.3c.47-.06.84-.45.87-.92l.17-2.53L15.24 13c.26-.26.35-.63.26-.98-.63-2.24-.01-4.57 1.64-6.22a6.406 6.406 0 0 1 5.06-1.86c1.91.15 3.58 1.1 4.73 2.68 1.78 2.48 1.51 6.01-.64 8.21zM22.83 6.1c-1.71 0-3.1 1.39-3.1 3.1s1.39 3.1 3.1 3.1c1.74 0 3.1-1.36 3.1-3.1 0-1.71-1.39-3.1-3.1-3.1zm0 4.2c-.66 0-1.1-.57-1.1-1.1 0-.66.57-1.1 1.1-1.1.66 0 1.1.57 1.1 1.1 0 .65-.45 1.1-1.1 1.1z",
  },
}
